import React from 'react'
import { motion } from 'framer-motion'
import { ArrowUpRight } from 'lucide-react'
import { useTranslation } from '../../hooks/use-i18n'

const ACADEM_URL = 'https://academ.one'
const HAT_SRC = `${process.env.PUBLIC_URL || ''}/academone-hat.png`

/**
 * Compact hero CTA → Academ.one (below ChessArenas banner).
 */
const AcademOneCorporateCta: React.FC = () => {
  const { t } = useTranslation()

  return (
    <motion.a
      href={ACADEM_URL}
      target="_blank"
      rel="noopener noreferrer"
      variants={{
        hidden: { opacity: 0, y: 10 },
        show: { opacity: 1, y: 0, transition: { duration: 0.4 } },
      }}
      whileHover={{ scale: 1.01 }}
      whileTap={{ scale: 0.99 }}
      className="group relative flex w-full max-w-3xl mx-auto mb-2 sm:mb-2.5 rounded-xl sm:rounded-2xl overflow-hidden border border-teal-400/25 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-400/80 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent"
      style={{
        background:
          'linear-gradient(135deg, rgba(15,23,42,0.95) 0%, rgba(11,51,51,0.7) 45%, rgba(20,24,40,0.95) 100%)',
        boxShadow: '0 8px 24px rgba(0, 65, 62, 0.28)',
      }}
      aria-label={t('landing.academOne.aria')}
    >
      <div
        className="absolute inset-0 opacity-35 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse at 15% 50%, rgba(45, 160, 140, 0.35), transparent 55%)',
        }}
      />

      <div className="relative z-10 w-full px-2.5 py-2 sm:px-3.5 sm:py-2.5 flex flex-wrap xs:flex-nowrap items-center gap-2 sm:gap-3 text-left">
        <div className="flex-1 min-w-0">
          <p className="font-display text-[13px] sm:text-sm font-bold text-white leading-snug break-words">
            {t('landing.academOne.title')}
          </p>
          <p className="text-xs sm:text-sm font-medium text-white/85 leading-snug mt-0.5 break-words">
            Developed by breakroomcup
          </p>
        </div>

        <span className="shrink-0 inline-flex items-center gap-1.5 rounded-lg bg-black/50 border border-white/15 px-2 py-1.5 group-hover:border-teal-400/50 transition-colors">
          <span
            className="inline-flex items-center gap-0.5 font-extrabold tracking-[-0.03em] leading-none select-none text-[13px] sm:text-sm"
            aria-hidden
          >
            <span className="text-white">academ</span>
            <span className="text-[#E07A6A]">one</span>
            <img
              src={HAT_SRC}
              alt=""
              className="h-3.5 w-3.5 sm:h-4 sm:w-4 object-contain shrink-0 ml-0.5"
            />
          </span>
          <ArrowUpRight className="w-3.5 h-3.5 text-teal-200/90 shrink-0" aria-hidden />
        </span>
      </div>
    </motion.a>
  )
}

export default AcademOneCorporateCta
